import { ReactNode, useEffect, useState } from "react"
import { useNavigate } from "react-router-dom";
import useColorPalette from "../../hooks/useColorPalette";

type ErrorScreenProps = {
    errCode?: string; // default to 'ERR_NETWORK' below
    isModal?: boolean; // optional
    setModalOpen?: React.Dispatch<React.SetStateAction<boolean>>; // optional
};

export default function ErrorScreen({
    errCode = "SESSION_EXPIRED",
    isModal = false,
    setModalOpen = ()=>{},
}: ErrorScreenProps) {
    const navigate = useNavigate();
    const { palette } = useColorPalette();

    const [ errComps, setErrComps ] = useState<{
        title: string,
        description: ReactNode,
        img: ReactNode,
        buttonNode: ReactNode,
    } | null>(null);



    useEffect(() => {
        let comp: {
            title: string,
            description: ReactNode,
            img: ReactNode,
            buttonNode: ReactNode,
        } | null = null;

        if (errCode === 'ERR_NETWORK' || errCode === "SESSION_EXPIRED") {
            const goLogin = () => {
                const here =
                    sessionStorage.getItem("redirectAfterLogin") ||
                    (window.location.pathname + window.location.search + window.location.hash);
                navigate(`/login?next=${encodeURIComponent(here)}`, { replace: true });
                if (isModal) {
                    setModalOpen(false);
                }
            };
            comp = {
                title: 'Session Expired',
                description: <p className="max-w-[600px] text-center text-default">Your current session as been expired. <br/> Please click on the button below to log in again.</p>,
                img: <img src={`${process.env.PUBLIC_URL}/session-timeout/${palette.logo}`} className="w-[160px]" alt='session-timeout'/>,
                buttonNode: (
                    <button onClick={goLogin} className="py-2 px-7 text-white bg-primary rounded font-medium hover:brightness-90 transition-all mt-2">Login</button>
                )
            };
        };

        setErrComps(comp);

        //eslint-disable-next-line
    }, [errCode]);


    return (
        <div className="w-full flex flex-col justify-center items-center p-10 gap-4">
            {errComps && (
                <>
                    {errComps.img}
                    <h2 className="text-[24px] font-semibold">{errComps.title}</h2>
                    {errComps.description}
                    {errComps.buttonNode}
                </>
            )}
        </div>
    )
}